import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';

export interface ExpandableCellProps {
  value: string;
  expandLabel?: string;
  collapseLabel?: string;
  defaultExpanded?: boolean;
  expandOverSize?: number;
  sx?: object;
}

export const ExpandableDetailsCell = ({
  value,
  expandLabel = 'Expand',
  collapseLabel = 'Collapse',
  defaultExpanded = false,
  expandOverSize = 100,
  sx = {},
}: ExpandableCellProps) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Box
      sx={{
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        fontFamily: 'monospace',
        fontSize: '0.8rem',
        minHeight: '80px',
        lineHeight: 1.3,
        alignContent: 'center',
        padding: '5px',
        ...sx,
      }}
    >
      <Typography variant='body2' component='div'>
        {expanded ? value : value.slice(0, expandOverSize) + (value.length > expandOverSize ? '...' : '')}
      </Typography>
      {value.length > expandOverSize && (
        <Button size='small' onClick={() => setExpanded(prev => !prev)} sx={{ mt: 1 }}>
          {expanded ? collapseLabel : expandLabel}
        </Button>
      )}
    </Box>
  );
};

export default ExpandableDetailsCell;
